<template>
  <Loader v-if="isLoading" />
  <div v-else>
    <BaseResult
      :questions="questions"
      :can_delete="can_delete"
      @deleteQuestion="deleteQuestion"
    />
  </div>
</template>

<script>
import BaseResult from '@/shared/review/views/employees/BaseResult'
import axios from 'axios'
import LikeQuestionResult from '../../components/results/employees/LikeQuestionResult'
import FiveScaleQuestionResult from '../../components/results/employees/FiveScaleQuestionResult'
import OpenQuestionResult from '../../components/results/employees/OpenQuestionResult'
import TenScaleQuestionResult from '../../components/results/employees/TenScaleQuestionResult'
import SixScaleQuestionResult from '../../components/results/employees/SixScaleQuestionResult'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'ShowResult',
  components: { BaseResult, SixScaleQuestionResult, TenScaleQuestionResult, LikeQuestionResult, FiveScaleQuestionResult, OpenQuestionResult },
  props: {
    event_id: { default: 0 },
    url: { type: String, required: true },
    can_delete: { default: 0 },
  },
  data () {
    return {
      questions: null,
      isLoading: true,
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {

    fetchData () {
      axios.get(this.url).then(({ data }) => {
        if (data.data[0] !== 'undefined') {
          this.questions = data.data.data
          this.question_index = 0
        }
      }).catch(error => defaultErrorMessage(error))
        .then(() => { this.isLoading = false })
    },

    deleteQuestion (event) {
      const question = event.question
      const index = event.index
      axios.delete(`/review/events/${this.event_id}/questions/${question.id}`).then(({ data }) => {
        this.questions.splice(index, 1)
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>
